/*
 *
 * Courses actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_COURSE,
  LOAD_COURSE_SUCCESS,
  LOAD_COURSE_ERROR,
  UPDATE_COURSE,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the courses, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_COURSES
 */
export function loadCourse(id, onDate = null, timeZone = null) {
  return {
    type: LOAD_COURSE,
    id,
    onDate,
    timeZone
  };
}

/**
 * Dispatched when the loadCourse are loaded by the request saga
 *
 * @param  {array} variables true for courses
 *
 * @return {object}      An action object with a type of LOAD_COURSE_SUCCESS passing the variables
 */
export function loadCourseSuccess(courseDetail, isTeacher) {
  return {
    type: LOAD_COURSE_SUCCESS,
    courseDetail, 
    isTeacher
  };
}

/**
 * Dispatched when loading the loadCourse fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_COURSE_ERROR passing the error
 */
export function loadCourseError(error) {
  return {
    type: LOAD_COURSE_ERROR,
    error,
  };
}

// Update for Single User
export function updateCourse(courseDetail) {
  return {
    type: UPDATE_COURSE,
    courseDetail,
  };
}
export function updateCourseSuccess(courseDetail) {
  return {
    type: UPDATE_COURSE_SUCCESS,
    courseDetail,
  };
}

export function updateCourseError(error) {
  return {
    type: UPDATE_COURSE_ERROR,
    error,
  };
}
